import Home from "app";

export const Svg = {
    vetirWhiteLogoSvg: require("./vetir-white-logo.svg"),
    tiktokSvg: require("./tiktok.svg"),
    instagramSvg: require("./instagram.svg"),
    returnsAndExchanges: require("./returnAndRefund.svg"),
    bacCard: require("./BAC.svg"),
    threeDots: require("./threeDots.svg"),
    calanderIcon: require("./calanderIcon.svg"),
    closetIcon: require("./closet.svg"),
    chatIcon: require("./chatIcon.svg"),
    recomadIcon: require("./recomad.svg"),
    stylingIcon: require("./segattions.svg"),
    creditCard: require("./credit-card.svg"),
    visaIcon: require("./visa.svg"),

    mastercardIcon: require("./cardLogos/Mastercard.svg"),
    amexIcon: require("./cardLogos/Amex.svg"),
    dinersIcon: require("./cardLogos/Diners.svg"),
    discoverIcon: require("./cardLogos/Discover.svg"),
    jcbIcon: require("./cardLogos/JCB.png"),
    sendIcon: require("./telegram-send-icon.svg"),
    aiLogo: require("./ai-logo.svg"),
    aistylistIcon: require("./ai-stylist-Icon.svg"),
    closeIcon: require("./closeRoundButton.svg"),
    closeButtonDark: require("./closeButtonDark.svg"),
    micIcon: require("./micIcon.svg"),
    cameraIcon: require("./cameraIcon.svg"),
    aiIcon: require("./ai-icon.svg"),
    sendButton: require("./sendButton.svg"),
    appleIcon: require("./Apple.svg"),
    gmailIcon: require("./Gmail.svg"),
    imageIcon: require("./imageIcon.svg"),
    searchIcon: require("./seachIcon.svg"),
    blueOutfitIcon: require("./blueOutfit.svg"),
    blueSearchIcon: require("./blueSearch.svg"),
    blueTailorIcon: require("./blueTailor.svg"),

    // Empty Screens

    shoppingBag: require("./emptyScreenIcons/shoppingBags.svg"),
    accessories: require("./emptyScreenIcons/accessories.svg"),
    bagsMan: require("./emptyScreenIcons/bagsMan.svg"),
    bagsWomen: require("./emptyScreenIcons/bagsWomen.svg"),
    clothingMan: require("./emptyScreenIcons/ClothingMan.svg"),
    clothingWomen1: require("./emptyScreenIcons/clothingWomen1.svg"),
    favIcons: require("./emptyScreenIcons/favIcons.svg"),
    langries: require("./emptyScreenIcons/langries.svg"),
    manageCards: require("./emptyScreenIcons/manageCards.svg"),
    newArrivals: require("./emptyScreenIcons/newArrivals.svg"),
    orderHistory: require("./emptyScreenIcons/orderHistory.svg"),
    savedAddress: require("./emptyScreenIcons/savedAddress.svg"),
    shoes: require("./emptyScreenIcons/Shoes.svg"),
    shoesMan: require("./emptyScreenIcons/ShoesMan.svg"),
    theEdit: require("./emptyScreenIcons/theEdit.svg"),
    videos: require("./emptyScreenIcons/videos.svg"),
    watchMan: require("./emptyScreenIcons/watchMan.svg"),
    watchWomen: require("./emptyScreenIcons/watchWomen.svg"),
    home: require("./emptyScreenIcons/home.svg"),
    beauty: require("./emptyScreenIcons/beauty.svg"),
    dislike: require("./dislike.svg"),
    addIcon: require("./addIcon.svg"),
    multipleProducts: require("./multiple.svg"),
    loadingIcon: require("./loadingIcon.svg"),
};
